export default "__VITE_ASSET__CdLmgv8v__"